import React, { useEffect, useState } from 'react'
import Search from '../HomePage/Search'
import axios from 'axios'
import JobCard from './JobCard'
import { BsSortUp } from "react-icons/bs";
import { useParams, useNavigate } from 'react-router-dom'
import img from '../../assets/sample.png'
// import save from '../../assets/save.png'
import { IoBookmarkOutline } from "react-icons/io5";
import { IoBookmark } from "react-icons/io5";
import { useSearch } from '../../hooks/SearchContext';

const JobPage = () => {

    const [jobs, setJobs] = useState([])
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)

        const getJobs = async () => {
            try {
                const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getalljobs`)

                console.log(data.data);
                setJobs(data.data);
                // setAllProducts(data.data);
            }
            catch (error) { console.log('There was an error getting the products!', error); }
        }

        getJobs();

    }, [])


    const { id } = useParams();
    const [job, setJob] = useState(null);

    useEffect(() => {
        if (!id) return;

        const getJob = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getjob/${id}`);
                if (response) {
                    setJob(response.data);
                    console.log(response.data)
                }
            } catch (error) {
                console.error('There was an error fetching the job!', error);
            }
        };

        getJob();
    }, [id]);

    const handleShare = async () => {
        const currentLink = window.location.href;
        if (navigator.share) {
            // Use the native share option if available
            try {
                await navigator.share({
                    title: "Check this out!",
                    url: currentLink,
                });
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            // Fallback: Copy link to clipboard
            try {
                await navigator.clipboard.writeText(currentLink);


                alert("Link copied to clipboard!");
            } catch (error) {
                console.error("Failed to copy link:", error);
            }
        }
    };


    const [showFilters, setShowFilters] = useState(false);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [filters, setFilters] = useState({
        category: [],
        locationType: [],
        experienceLevel: [],
        salaryRange: [],
    });
    const [sortOrder, setSortOrder] = useState("latest");


    const handleCheckboxChange = (filterType, value) => {
        setFilters((prev) => {
            const updatedFilters = { ...prev };
            if (updatedFilters[filterType].includes(value)) {
                updatedFilters[filterType] = updatedFilters[filterType].filter((item) => item !== value);
            } else {
                updatedFilters[filterType] = [...updatedFilters[filterType], value];
            }
            return updatedFilters;
        });
    };

    useEffect(() => {
        let filtered = jobs;

        Object.keys(filters).forEach((key) => {
            if (filters[key].length > 0) {
                filtered = filtered.filter((job) => filters[key].includes(job[key]));
            }
        });

        // Apply Sorting
        if (sortOrder === "latest") {
            filtered = filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        } else if (sortOrder === "earliest") {
            filtered = filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        }

        setFilteredJobs(filtered);
    }, [filters, jobs, sortOrder]);


    const { savedJobs, setSavedJobs } = useSearch();

    const toggleSaveJob = (jobId) => {
        setSavedJobs((prev) =>
            prev.includes(jobId) ? prev.filter((id) => id !== jobId) : [...prev, jobId]
        );
    };


    return (
        <div className='bigscreen px-16 pt-3 pb-16'>

            <div className="relative flex flex-col gap-4 w-full p-6 rounded-[20px] shadow bg-[#F0EAEA8A]">

                <div className='flex justify-between items-center'>
                    <h2 className="text-lg font-semibold">Jobs</h2>

                    <div className='flex items-center gap-10'>

                        <div className='flex items-center cursor-pointer'
                            onClick={() => setShowFilters(!showFilters)}
                        >
                            {showFilters ? "Hide Filters" : "Show Filters"}
                        </div>


                        <div className='flex items-center cursor-pointer'>
                            <BsSortUp className='text-black' />

                            <select className='bg-transparent border-none outline-none min-w-[80px] px-2 cursor-pointer'
                                onChange={(e) => setSortOrder(e.target.value)}
                                value={sortOrder}
                            >
                                {/* <option value="">Sort</option> */}
                                <option value="latest">Latest First</option>
                                <option value="earliest">Earliest First</option>
                            </select>
                        </div>

                    </div>

                </div>

                <div className='flex gap-10'>

                    <div className='flex flex-col gap-6 w-full overflowScrollY max-h-[calc(100vh-190px)] max-w-[360px]'>
                        {filteredJobs?.length > 0 && filteredJobs.map((job) => {
                            return (
                                <JobCard key={job._id} job={job} />
                            )
                        })}
                    </div>

                    <div className='sticky top-20 w-full overflowScrollY max-h-[calc(100vh-190px)] bg-white rounded-[32px] shadow'>
                        <div className='py-6 px-8 rounded-[32px] flex flex-col gap-6 w-full'>

                            <div className='flex gap-4'>

                                <div className='h-14'>
                                    <img src={img} className='h-full object-contain' />
                                </div>

                                <div className='flex flex-col flex-grow gap-2 justify-between'>
                                    <div className='text-sm font-medium'>
                                        {job?.title}
                                    </div>

                                    <div className='text-[11px] flex gap-3 font-light text-[rgba(0, 0, 0, 0.59)]'>
                                        <div>{job?.department}</div>
                                        <div>{job?.applicants} Applicants</div>
                                    </div>

                                    <div className='text-[11px] font-light text-[rgba(0, 0, 0, 0.59)]'>
                                        Posted 3 Days Ago
                                        <br />{job?._id}
                                    </div>
                                </div>


                                <div className='h-6'>
                                    <IoBookmarkOutline
                                        className={`text-2xl cursor-pointer transition-all ${savedJobs.includes(job?._id) ? "hidden" : "block"}`}
                                        onClick={() => toggleSaveJob(job?._id)}
                                        onMouseEnter={(e) => e.currentTarget.style.color = "#EE7828B5"} // Change color on hover
                                        onMouseLeave={(e) => e.currentTarget.style.color = ""}
                                    />

                                    <IoBookmark
                                        className={`text-2xl cursor-pointer transition-all ${savedJobs.includes(job?._id) ? "block" : "hidden"}`}
                                        onClick={() => toggleSaveJob(job?._id)}
                                        onMouseEnter={(e) => e.currentTarget.style.color = "#EE7828B5"} // Change color on hover
                                        onMouseLeave={(e) => e.currentTarget.style.color = ""}
                                    />
                                </div>

                            </div>

                            <div className='flex gap-6'>
                                <button className='button' onClick={() => navigate(`/apply/${job?._id}`)}>
                                    Apply
                                </button>
                                {job?.allowSharing == true &&
                                    <button className='button white' onClick={handleShare}>
                                        Share
                                    </button>
                                }
                            </div>

                            <div className='border-b'
                                style={{ borderColor: "rgba(0, 0, 0, 0.59)" }}
                            ></div>

                            <div className='flex flex-col gap-4'>
                                <div className='font-medium'>Job Details</div>

                                <div className='pl-5 text-xs text-[rgba(0, 0, 0, 0.59)] w-fit'>
                                    <div className='grid grid-cols-2 items-center justify-items-start gap-4'>
                                        <div>Job Type:</div>
                                        <div className='JobLabel blue'>{job?.category}</div>
                                    </div>

                                    <div className='mt-1 grid grid-cols-2 items-center justify-items-start gap-4'>
                                        <div>Experience Level:</div>
                                        <div className='JobLabel purple'>{job?.experienceLevel}</div>
                                    </div>

                                    <div className='mt-1 grid grid-cols-2 items-center justify-items-start gap-4'>
                                        <div>Location Type:</div>
                                        <div className='JobLabel peach'>{job?.locationType}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='border-b'
                                style={{ borderColor: "rgba(0, 0, 0, 0.59)" }}
                            ></div>

                            <div className='flex flex-col gap-4'>
                                <div className='font-medium'>Salary Range</div>

                                <div className='font-semibold text-xs pl-5'>
                                    ₹ {job?.salaryRange}
                                </div>

                            </div>

                            <div className='border-b'
                                style={{ borderColor: "rgba(0, 0, 0, 0.59)" }}
                            ></div>

                            <div className='flex flex-col gap-4'>
                                <div className='font-medium'>Full Job Description</div>

                                <div className='font-light text-xs pl-5'>
                                    {job?.description}
                                </div>
                            </div>


                            <div className='flex flex-col gap-4'>
                                <div className='font-medium'>Requirements</div>

                                <div className='font-light text-xs pl-5'>
                                    {job?.requirements}
                                </div>
                            </div>


                            <div className='flex flex-col gap-4'>
                                <div className='font-medium'>Responsibilities</div>

                                <div className='font-light text-xs pl-5'>
                                    {job?.responsibilities}
                                </div>
                            </div>

                        </div>
                    </div>

                </div>


                <div className={`absolute top-[58px] right-[156px] flex flex-col gap-6 w-full max-w-[280px] bg-white rounded-[20px] shadow text-sm  transition-all duration-150 ease-in-out px-6
                    ${showFilters ?
                        "max-h-[500px] h-auto overflowScrollY py-6" : "max-h-0 overflow-hidden"
                    }`}
                >
                    <div>
                        <h3 className="font-medium">Category</h3>
                        {['Contract', 'Full-Time', 'Freelance'].map((category) => (
                            <label key={category} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.category.includes(category)}
                                    onChange={() => handleCheckboxChange('category', category)}
                                />
                                <span>{category}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Location Type</h3>
                        {['Remote', 'Hybrid', 'In-office'].map((location) => (
                            <label key={location} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.locationType.includes(location)}
                                    onChange={() => handleCheckboxChange('locationType', location)}
                                />
                                <span>{location}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Experience Level</h3>
                        {['Entry Level', 'Mid Level', 'Senior Level'].map((level) => (
                            <label key={level} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.experienceLevel.includes(level)}
                                    onChange={() => handleCheckboxChange('experienceLevel', level)}
                                />
                                <span>{level}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Salary Range</h3>
                        {['<3 LPA', '3-5 LPA', '5-10 LPA'].map((range) => (
                            <label key={range} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.salaryRange.includes(range)}
                                    onChange={() => handleCheckboxChange('salaryRange', range)}
                                />
                                <span>{range}</span>
                            </label>
                        ))}
                    </div>
                </div>


            </div>

        </div>
    )
}

export default JobPage